export const PASTE_SETTINGS = 'hsPaste';
export const hspasteConfig = {
  CLEAR_ALL_STYLES: 'pasteClearAllStyles',
  DEFAULT_ATTRIBUTES_MAP: 'pasteDefaultAttributesMap',
  DEFAULT_STYLES_MAP: 'pasteDefaultStylesMap',
  EMBED_URL_PASTING: 'pasteEmbedUrls',
  FORMAT_TRANSFORM_MAP: 'pasteFormatTransformMap',
  IMAGES_UPLOAD_FILE_ACCESS: 'imagesUploadFileAccess'
};